/*
  Wahooo: keep infinite scroll moving when sold-out products are hidden.

  With "Hide sold-out products" on, a page of results can shrink to a few
  cards (or none). Horizon's infinite scroll only loads the next page when its
  bottom sentinel *enters* the viewport, so if an appended page doesn't push
  the sentinel off-screen, loading stalls. After each batch of cards lands,
  re-observe the sentinel: IntersectionObserver.observe() always fires an
  initial callback, so Horizon loads the next page if the sentinel is still
  visible. Stops on its own at the last page (Horizon checks data-last-page).

  Loaded only when the setting is on (sections/main-collection, search-results).
*/

const CARD_SELECTOR = '[ref="cards[]"]';

/** @param {Element} list - a <results-list> element */
function nudgeSentinel(list) {
  const observer = list.infinityScrollObserver;
  const sentinel = list.querySelector('[ref="viewMoreNext"]');
  if (!observer || !sentinel) return;

  observer.unobserve(sentinel);
  observer.observe(sentinel);
}

function watch(list) {
  if (list.dataset.wahoooSoldOutScroll) return;
  list.dataset.wahoooSoldOutScroll = 'true';

  new MutationObserver((mutations) => {
    const cardsAdded = mutations.some((mutation) =>
      [...mutation.addedNodes].some((node) => node instanceof Element && node.matches(CARD_SELECTOR))
    );
    // Let Horizon finish its own post-append work before re-checking.
    if (cardsAdded) requestAnimationFrame(() => nudgeSentinel(list));
  }).observe(list, { childList: true, subtree: true });
}

document.querySelectorAll('results-list').forEach(watch);
